import { colorConfig } from '../filtersConfig'
import type { Facet, FacetValue } from '../types'

type RateProps = {
  key: string
  quantity: number
  label: string
  selected: boolean
  value: string
}

export const formatRange = (min: number, max: number) =>
  `${min.toFixed(2)}:${max.toFixed(2)}`

const mainFacetNames = [
  'loja de retirada',
  'opções de entrega',
  'gênero',
  'idade',
  'tamanho',
  'tipo de produto',
  'esporte',
]

export function mapOrderFacets(facets: Facet[], key: 'key' | 'name') {
  const mainFacets = facets
    .filter((facet) => mainFacetNames.includes(facet.name.toLocaleLowerCase()))
    .sort((a, b) => {
      const A = a[key]
      const B = b[key]

      if (mainFacetNames.indexOf(A) > mainFacetNames.indexOf(B)) {
        return 1
      }

      return -1
    })

  const otherFacets = facets
    .filter((facet) => !mainFacetNames.includes(facet.name.toLocaleLowerCase()))
    .sort((a, b) => {
      const A = a[key].toLowerCase()
      const B = b[key].toLowerCase()

      if (A < B) {
        return -1
      }

      if (A > B) {
        return 1
      }

      return 0
    })

  return { mainFacets, otherFacets }
}

export const getMinimumPrice = (facetValues: FacetValue[]) => {
  let minimumValue = Infinity

  facetValues.forEach((item) => {
    if (item.range && item.range.from < minimumValue) {
      minimumValue = item.range.from
    }
  })

  return minimumValue
}

export const getMaxPrice = (facetValues: FacetValue[]) => {
  let maxValue = -Infinity

  facetValues.forEach((value) => {
    if (value.range && value.range.to > maxValue) {
      maxValue = value.range.to
    }
  })

  return maxValue
}

export const handleActiveFacets = (acc: Facet[], item: Facet) => {
  const newItem = { ...item, values: item.values, showAll: false }

  if (
    item.name.toLocaleLowerCase() === 'blueproduct' ||
    item.name.toLocaleLowerCase() === 'marca própria' ||
    item.name.toLocaleLowerCase() === 'sellername'
  ) {
    return acc
  }

  if (item.name === 'Gênero') {
    return [newItem, ...acc]
  }

  if (item.name === 'Avaliações') {
    newItem.values.sort((rate1: RateProps, rate2: RateProps) => {
      return rate1.label < rate2.label ? 1 : -1
    })
  }

  if (item.name === 'Cor predominante') {
    const newFacetValues = newItem.values.filter((color) =>
      Boolean(colorConfig[color.label])
    )

    newItem.values = newFacetValues
  }

  acc.push(newItem)

  return acc
}

export const sortFacetValues = (values: FacetValue[], facetName: string) => {
  const labelSortMap: Record<string, keyof typeof sortStrategies> = {
    'Cor predominante': 'name',
    Esporte: 'quantity',
  }

  const sortStrategies = {
    name: (vals: FacetValue[]) =>
      [...vals].sort((a, b) => a.label.localeCompare(b.label)),
    quantity: (vals: FacetValue[]) =>
      [...vals].sort((a, b) => b.quantity - a.quantity),
  }

  const strategy = labelSortMap[facetName]

  return strategy ? sortStrategies[strategy](values) : values
}
